import { createFormikComponent } from '../../../utilities/createFormikComponent';
import TextEntryStandard from './TextEntryStandard';

const FormikTextEntryStandard = createFormikComponent(TextEntryStandard);

export { TextEntryStandard, FormikTextEntryStandard };
